/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Form_LabelInputs */

const en_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foot Pedal Settings`)
};

const fr_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de pédale`)
};

const de_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fußpedaleinstellungen`)
};

const it_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni del pedale`)
};

const ru_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки ножной педали`)
};

const es_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes del pedal`)
};

const zh_cn2_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脚踏板设置`)
};

const ja_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フットペダルの設定`)
};

const hi_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फुट पेडल सेटिंग्स`)
};

const pt_pt2_options_pedal_form_label = /** @type {(inputs: Options_Pedal_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações do pedal`)
};

/**
* | output |
* | --- |
* | "Foot Pedal Settings" |
*
* @param {Options_Pedal_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_form_label = /** @type {((inputs?: Options_Pedal_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_form_label(inputs)
	if (locale === "de") return de_options_pedal_form_label(inputs)
	if (locale === "it") return it_options_pedal_form_label(inputs)
	if (locale === "ru") return ru_options_pedal_form_label(inputs)
	if (locale === "es") return es_options_pedal_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_form_label(inputs)
	if (locale === "ja") return ja_options_pedal_form_label(inputs)
	if (locale === "hi") return hi_options_pedal_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_form_label(inputs)
	return en_options_pedal_form_label(inputs)
});